import { render, staticRenderFns } from "./CartaoDeDatas.vue?vue&type=template&id=3c770bf6&scoped=true"
import script from "./CartaoDeDatas.vue?vue&type=script&setup=true&lang=js"
export * from "./CartaoDeDatas.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CartaoDeDatas.vue?vue&type=style&index=0&id=3c770bf6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c770bf6",
  null
  
)

export default component.exports